import { apiInstance } from "./apiInstance"
import { formInstance } from "./formInstance"
import { getUniqueID } from "./getUniqueID"
import { parseJwt } from "./parseJwt"
import { randomModalAnimationClasses } from "./randomModalAnimationClasses"
import { sleep } from "./sleep"
import { stateInstance } from "./stateInstance"
import { enterFullScreen, exitFullScreen } from "./fullScreen"
import { getStartAndEndTime } from "./getStartAndEndTime"
import { getChartDurationTypeFormat } from "./getDurationTypeFormat"

export const HELPER_FUNCTIONS = {
  apiInstance: apiInstance,
  formInstance: formInstance,
  stateInstance: stateInstance,
  parseJwt: parseJwt,
  getUniqueID: getUniqueID,
  randomModalAnimationClasses: randomModalAnimationClasses,
  sleep: sleep,
  enterFullScreen: enterFullScreen,
  exitFullScreen: exitFullScreen,
  getStartAndEndTime: getStartAndEndTime,
  getChartDurationTypeFormat: getChartDurationTypeFormat,
}